import {ProfileSettingsRevenueComponent} from './profile.settings.revenue.component';
import {RevenueDistributionExceptionComponent} from './exceptions/revenue-distribution.exception.component';
import {RevenueDistributionService} from './api/service/revenue-distribution.service';
import {DistributionRulesComponent} from './rules/distribution-rules.component';
import {SharesValidatorDirective} from './rules/shares-validator.directive';
import {EditRevenueDistributionRuleComponent} from './rules/edit-distribution-rule.component';
import {SharePipe} from './rules/share.pipe';
import {RevenueDistributionExceptionsComponent} from './exceptions/revenue-distribution-exceptions.component';
import {UniqueIdGenerator} from './exceptions/unique-id-generator.service';
import {ExceptionValidatorDirective} from './exceptions/exception-validator.directive';
import {ExceptionSettingsConflictValidatorDirective} from './exceptions/exception-settings-conflict-validator.directive';
import {RuleHoverDirective} from './rules/rule-hover.directive';
import {ConditionsSelectorComponent} from './exceptions/conditions/conditions-selector.component';
import {InvalidControlNotifierDirective} from './invalid-control-notifier.directive';
import {ExceptionTypeService} from "./exception-type.service";

export const REVENUE_DISTRIBUTION_SETTINGS_COMPONENTS = [
    ProfileSettingsRevenueComponent,
    DistributionRulesComponent,
    EditRevenueDistributionRuleComponent,
    RevenueDistributionExceptionComponent,
    RevenueDistributionExceptionsComponent,
    ConditionsSelectorComponent,
    SharesValidatorDirective,
    ExceptionValidatorDirective,
    ExceptionSettingsConflictValidatorDirective,
    RuleHoverDirective,
    InvalidControlNotifierDirective,
    SharePipe
];
export const REVENUE_DISTRIBUTION_PROVIDERS = [
    RevenueDistributionService,
    UniqueIdGenerator,
    ExceptionTypeService
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/index.ts